var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faMagnifyingGlass } from '@fortawesome/pro-regular-svg-icons';
import { Icon } from '../SbGlobal/styles';
import { IconContainer, SearchContainer, SearchInput } from './styles';
import { sbColors as colors } from 'components/UI-helpers/colors';
export var Searchbar = function (_a) {
    var placeholder = _a.placeholder, style = _a.style, onChange = _a.onChange, onFocus = _a.onFocus;
    var handleOnChange = function (e) {
        onChange(e.target.value);
    };
    return (_jsxs(SearchContainer, __assign({ style: style }, { children: [_jsx(IconContainer, { children: _jsx(Icon, { icon: faMagnifyingGlass, color: colors.greyActive }) }), _jsx(SearchInput, { autoFocus: true, type: "search", onFocus: onFocus, onChange: function (e) {
                    e.stopPropagation();
                    handleOnChange(e);
                }, placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : 'Search' })] })));
};
